<script lang="ts" setup>
  import { IconInfoSquareRounded } from '@tabler/icons-vue';
  import type { VMessageProps } from './types';

  withDefaults(defineProps<VMessageProps>(), {
    closable: false,
    severity: 'warn',
  });
</script>

<template>
  <Message :closable="closable" :severity="severity">
    <template #icon>
      <IconInfoSquareRounded v-if="severity === 'info'" class="mr-8 w-[20px]" />
      <i v-else />
    </template>
    <slot />
  </Message>
</template>
